/** Saved originals keep record identity even when two ads share a media asset. */
export interface SavedBrandAdReference {
  clientId: string;
  src: string;
  brandId: number;
  savedAdId: number;
  source: 'saved_public_brand_ad_analysis';
  externalId?: string;
  mediaType?: string;
  originalHeadline?: string;
  originalCopy?: string;
}

export function savedBrandAdCanvasId(brandId: number, adId: number, revision?: string): string {
  return `saved-brand-ad-${brandId}-${adId}${revision ? `-${revision}` : ''}`;
}

export function isSavedBrandAdCanvasId(id: unknown): id is string {
  return typeof id === 'string' && /^saved-brand-ad-\d+-\d+(?:-[a-f0-9]{12})?$/.test(id);
}

/** Generated tiles may still have temporary IDs; only saved originals have strict record IDs. */
export function savedBrandAdSelectionReferences(selectedIds: string[], images: Array<{id:string;src:string}>, referenceUrls: string[]): Array<{clientId:string;src:string}> {
  return selectedIds.filter(isSavedBrandAdCanvasId).flatMap(clientId => {
    const image=images.find(image=>image.id===clientId);
    return image && referenceUrls.includes(image.src)?[{clientId,src:image.src}]:[];
  });
}

export function canvasImageSourceKey(row: { clientId?: string; id?: string | number; src?: string | null; variantOfImageId?: number | null }): string | null {
  const clientId = row.clientId ?? row.id;
  if (isSavedBrandAdCanvasId(clientId)) return clientId;
  return row.src ? JSON.stringify([row.src, row.variantOfImageId ?? null]) : null;
}
